var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#850040",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.897 15.78l-1.955-3.363c.4-.732.608-1.553.606-2.386a5.02 5.02 0 0 0-1.48-3.558 5.061 5.061 0 0 0-7.143 0 5.02 5.02 0 0 0-1.479 3.558 4.943 4.943 0 0 0 .606 2.386L5.097 15.78a.716.716 0 0 0 .266.983c.11.063.235.096.361.095h2.071l1.054 1.768a.72.72 0 0 0 .13.158c.133.129.312.2.497.202h.101a.723.723 0 0 0 .527-.352l1.393-2.387 1.392 2.408a.72.72 0 0 0 .527.345h.101a.723.723 0 0 0 .628-.352l1.053-1.768h2.071a.724.724 0 0 0 .628-.36.717.717 0 0 0 0-.74zm-8.428 1.1l-.642-1.071a.72.72 0 0 0-.613-.352H6.965l1.032-1.783a5.057 5.057 0 0 0 2.576 1.323L9.47 16.88zm2.028-3.256c-.714 0-1.411-.21-2.005-.605a3.58 3.58 0 0 1-.547-5.529 3.612 3.612 0 0 1 3.932-.78c.66.273 1.223.733 1.62 1.324a3.583 3.583 0 0 1-.45 4.538 3.615 3.615 0 0 1-2.55 1.052zm3.283 1.833a.723.723 0 0 0-.614.352l-.642 1.07-1.096-1.904a5.102 5.102 0 0 0 2.568-1.322l1.032 1.782-1.248.022z",
    fill: "#850040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experienceIcon.a5ac01865d78eecb93e078616e8aa07e.svg";
export { ForwardRef as ReactComponent };